import { useState } from 'react'

import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { Trade } from '@App/redux/slices/trade/trades/types'
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'
import { TradeInfoModal } from '@App/ui/crypto_exchange/desktop/components/modals/TradeInfoModal'

import { Select } from '../../../../../SpotOrderTrade/components/Select'
import { formatDate, formatTime, useTrades } from '../../../../model'
import { TradeInfo } from '../../../TradeInfo'
import { Card } from '../Card'

import s from './styles.module.scss'

enum Result {
  Profit = 'Profit',
  Loss = 'Loss',
}
const options = [
  { name: Result.Profit, value: Result.Profit },
  { name: Result.Loss, value: Result.Loss },
]

export const TopTrades = () => {
  const [selectedTrade, setSelectedTrade] = useState<Trade | null>(null)
  const [tradeResult, setTradeResult] = useState(Result.Profit)
  const { trades } = useTrades()
  const closedTrades = trades.filter((v) => v.status === 'closed')

  const targetTrades = closedTrades.filter((v) => (tradeResult === Result.Profit ? v.result > 0 : v.result < 0))

  return (
    <Card
      className={s.container}
      title="Top Trades"
      contentClassName={s.content}
      headerRightElement={
        <Select
          value={tradeResult}
          options={options}
          containerClassName={s.selectContainer}
          inputClassName={s.select}
          optionClassName={s.option}
          onChange={(val) => setTradeResult(val as Result)}
        />
      }
    >
      <div className={s.header}>
        <div className={s.segment}>Market</div>
        <div className={cn(s.segment, s.end)}>Profit & Loss</div>
      </div>
      <div className={s.trades}>
        {targetTrades.map((trade) => (
          <div key={trade.id} className={s.trade} onClick={() => setSelectedTrade(trade)}>
            <div className={cn(s.segment, s.left)}>
              <MarketIcon
                className={s.icon}
                source_currency={trade.market.source}
                target_currency={trade.market.target}
              />
              <div className={s.content}>
                <div className={s.name}>
                  {trade.market.source}/{trade.market.target}
                </div>
                <div className={s.date}>
                  {formatDate(trade.open_time)} {formatTime(trade.open_time)}
                </div>
              </div>
            </div>
            <div className={cn(s.segment, s.right, trade.result < 0 && s.negative)}>
              {getValueWithCurrency(trade.market.target, trade.result)}
            </div>
          </div>
        ))}
      </div>
      {!!selectedTrade && (
        <TradeInfoModal
          isOpen={!!selectedTrade}
          setIsOpen={() => setSelectedTrade(null)}
          headerContent={`Trade ${selectedTrade.status}`}
        >
          <TradeInfo trade={selectedTrade} />
        </TradeInfoModal>
      )}
    </Card>
  )
}
